<div class="at-a-glance-section">
  <ssg-expander [open]="allExpanded || sectionExpanded" (stateChanged)="sectionExpanded = $event"
    [expandable]="hasData">
    <!-- Payrolls Header -->
    <div expander-content>
      <div class="at-a-glance-section-header" data-automation="at-a-glance-payroll-header">
        <ukg-popover #payrollTooltip class="at-a-glance-tooltip" type="custom">
          <span>
            <b>Payrolls - <span translate>AT_A_GLANCE.PANEL_TITLE</span></b> <br /><br />
            <p [innerHtml]=" 'AT_A_GLANCE.PAYROLL_HELP_TEXT' | translate "></p>
          </span>
          </ukg-popover>
          <ukg-popover #productDetailsTooltip class="at-a-glance-tooltip" type="custom">
          <div *ngIf="loadingCounts">
            <p translate [translateParams]="{ closedPayrollCount: productInfo.counts.closedPayrollCount, totalPayrollCount: productInfo.counts.expectedPayrollCount }" data-automation="at-a-glance-payroll-product-details-title">AT_A_GLANCE.PAYROLL_PRODUCT_DETAILS_TITLE</p>
            <p translate [translateParams]="{ amount: productInfo.totalAmount | ulticurrency:'1.02':undefined:true, count: productInfo.totalCount }" data-automation="at-a-glance-payroll-product-details-total">AT_A_GLANCE.PAYROLL_PRODUCT_DETAILS_TOTALS</p>
            <ukg-list>
              <ng-container *ngFor="let profile of portionProfiles; index as i">
                <ukg-list-item *ngIf="!profile.isInvalid && productInfo.portionRollups[i].totalAmount" translate
                  [translateParams]="{ name: profile.titleKey | translate, amount: productInfo.portionRollups[i].totalAmount | ulticurrency:'1.0-2':undefined:true, count: productInfo.portionRollups[i].totalCount }">
                  AT_A_GLANCE.PAYROLL_CLOSED_DETAILS_PORTION
                </ukg-list-item>
              </ng-container>
            </ukg-list>
            <p [innerHtml]="'AT_A_GLANCE.PAYROLL_CLOSED_DETAILS_NOTES' | translate"></p>
          </div>
          </ukg-popover>
        <div class="flex-row">
          <div class="flex-60">
            <div class="header-position">
            <strong class="section-title" translate>COMMON.PAYROLL</strong>
            <ukg-icon name="help" (click)="payrollTooltip.present($event.target)" class="clickable heading-icon-spacing"></ukg-icon>
          </div>
          </div>
          <div class="flex-40" data-automation="at-a-glance-payroll-amount">
            <ssg-currency *ngIf="hasData" (click)="productDetailsTooltip.present($event.target)" class="clickable currency-class" [amount]="productInfo.totalAmount" [showFullAmount]="true" container="body" placement="right"></ssg-currency>
          </div>
        </div>
        <div class="text-xs header-position section-metadata"
          *ngIf="sectionExpanded && totalPayrollCounts && totalPayrollCounts.expectedPayrollCount"
          data-automation="at-a-glance-payroll-pay-groups-closed">
          {{ 'AT_A_GLANCE.PAY_GROUPS_CLOSED' | translate:{closed: totalPayrollCounts.closedPayrollCount, total:
          totalPayrollCounts.expectedPayrollCount} }}
        </div>
      </div>
    </div>
    <!-- Payrolls Display -->
    <div expanded-content>
      <div>
        <div *ngIf="hasData" class='at-a-glance-item'>
          <div>
            <div class="flex-100 flex-column">
              <div *ngFor='let payroll of productInfo.payrolls' class='at-a-glance-item' data-automation="at-a-glance-payroll-payroll-info">
                <ukg-popover #payGroupToolTip class="at-a-glance-tooltip" type="custom">{{payroll.groupCode}}</ukg-popover>
                <ssg-expander [open]="allExpanded && isPayrollClosed(payroll)" (stateChanged)="productInfo.payrollsExpanded.set(payroll, $event)" [expandable]="isPayrollClosed(payroll)">
                  <!-- Paygroup Overviews -->
                  <div expander-content>
                    <div class="at-a-glance-row flex-100 flex-row">
                      <ukg-popover #paygroupDetailsTooltip class="at-a-glance-tooltip" type="custom">
                        <div *ngIf="isPayrollPosting(payroll) && !isPayrollClosed(payroll)">
                          <p translate>AT_A_GLANCE.PAYROLL_POSTING_DETAILS</p>
                          <p translate>AT_A_GLANCE.PAYROLL_POSTING_DETAILS_NOTES</p>
                        </div>
                        <div *ngIf="!isPayrollPosting(payroll) && !isPayrollClosed(payroll)">
                          <p translate>AT_A_GLANCE.PAYROLL_PENDING_DETAILS</p>
                          <p translate>AT_A_GLANCE.PAYROLL_PENDING_DETAILS_NOTES</p>
                        </div>
                        <div *ngIf="isPayrollClosed(payroll)">
                          <p translate [translateParams]="{ code: payroll.payGroup, percontrol: payroll.runNumber, type: getPaygroupTypeKey(payroll) | translate:{ paySequence: payroll.paySequence - 1 } }">
                            AT_A_GLANCE.PAYROLL_CLOSED_DETAILS_TITLE</p>
                          <p translate [translateParams]="{ amount: payroll.payStatusCounts.collectablePaysAmount | ulticurrency:'1.02':undefined:true, count: payroll.payStatusCounts.collectablePaysCount }">
                            AT_A_GLANCE.PAYROLL_CLOSED_DETAILS_TOTALS</p>
                          <ukg-list>
                            <ng-container *ngFor="let profile of portionProfiles">
                              <ukg-list-item *ngIf="!profile.isInvalid && payroll.payStatusCounts[profile.totalProperty] > 0"
                                translate [translateParams]="{ name: profile.titleKey | translate, amount: payroll.payStatusCounts[profile.totalProperty] | ulticurrency:'1.0-2':undefined:true, count: payroll.payStatusCounts[profile.countProperty] }">
                                AT_A_GLANCE.PAYROLL_CLOSED_DETAILS_PORTION
                              </ukg-list-item>
                            </ng-container>
                          </ukg-list>
                          <p [innerHtml]="'AT_A_GLANCE.PAYROLL_CLOSED_DETAILS_NOTES' | translate"></p>
                        </div>
                      </ukg-popover>
                      <div class="flex-60">
                        <span class="help-cursor-hover section-title" (click)="paygroupDetailsTooltip.present($event.target)">
                        {{ 'AT_A_GLANCE.PAYGROUP_FORMAT' | translate:{ code: payroll.payGroup, type: getPaygroupTypeKey(payroll) | translate:{ paySequence: payroll.paySequence - 1 } } }}
                        </span>
                        <div class="section-metadata at-a-glance-item-expanded">
                          <span *ngIf="productInfo.payrollsExpanded.get(payroll)">{{ 'AT_A_GLANCE.PAYROLL_CLOSED' |
                            translate:{ dayOfWeek: payroll.closedDate | ultishortdate:'ddd':false, month: payroll.closedDate |
                            ultishortdate:'M':false, day: payroll.closedDate | ultishortdate:'D':false, year: payroll.closedDate |
                            ultishortdate:'YY':false, shortDate: payroll.closedDate | ultishortdate:undefined:false } }}</span>
                          <span *ngIf="isPayrollPosting(payroll) && !isPayrollClosed(payroll)"
                            translate>AT_A_GLANCE.PAYROLL_POSTING</span>
                          <span *ngIf="!isPayrollPosting(payroll) && !isPayrollClosed(payroll)"
                            translate>AT_A_GLANCE.PAYROLL_PENDING</span>
                        </div>
                      </div>
                      <div class="flex-40" *ngIf="!productInfo.payrollsExpanded.get(payroll)" class="section-title">
                        <ssg-currency [amount]="payroll.payStatusCounts.collectablePaysAmount"
                          *ngIf="isPayrollClosed(payroll)" [showFullAmount]="true" container="body" placement="right">
                        </ssg-currency>
                        <div class="pull-right" *ngIf="!isPayrollClosed(payroll)" translate>
                          AT_A_GLANCE.PAYGROUP_OPEN_TOTAL</div>
                      </div>
                    </div>
                  </div>
                  <!-- Paygroup Breakdowns -->
                  <div expanded-content>
                    <div class='at-a-glance-item-expanded' *ngFor="let profile of portionProfiles">
                      <div class='at-a-glance-row flex-100 flex-row' *ngIf="payroll.payStatusCounts[profile.totals.countProperty] > 0 || payroll.payStatusCounts[profile.totals.totalProperty] > 0">
                        <div class="flex-20px"></div>
                        <div class="flex-1-1-calc flex-row">
                          <ukg-popover #paygroupDetailsTooltipDisplay class="at-a-glance-tooltip" type="custom">
                            <div>
                              <div *ngIf="!profile.isInvalid">
                                <p translate
                                  [translateParams]="{ code: payroll.payGroup, percontrol: payroll.runNumber, type: getPaygroupTypeKey(payroll) | translate:{ paySequence: payroll.paySequence - 1 } }">
                                  AT_A_GLANCE.PAYROLL_CLOSED_DETAILS_TITLE</p>
                                <ukg-list>
                                  <ukg-list-item translate
                                    [translateParams]="{ name: profile.titleKey | translate, amount: payroll.payStatusCounts[profile.totals.totalProperty] | ulticurrency:'1.0-2':undefined:true, count: payroll.payStatusCounts[profile.totals.countProperty] }">
                                    AT_A_GLANCE.PAYROLL_CLOSED_DETAILS_PORTION</ukg-list-item>
                                  <ukg-list-item *ngIf="profile.totalCountProperty" translate
                                    [translateParams]="{ totalCount: payroll.payStatusCounts[profile.totalCountProperty] }">
                                    {{profile.totalCountKey}}</ukg-list-item>
                                </ukg-list>
                              </div>
                              <div *ngIf="profile.isInvalid">
                                <p translate
                                  [translateParams]="{ amount: payroll.payStatusCounts[profile.totals.totalProperty] | ulticurrency:'1.0-2':undefined:true, count: payroll.payStatusCounts[profile.totals.countProperty] }">
                                  AT_A_GLANCE.PORTION_INVALID_DETAILS_TITLE</p>
                              </div>
                              <ukg-list>
                                <ukg-list-item *ngFor="let subtotal of profile.subtotals" translate
                                  [translateParams]="{ amount: payroll.payStatusCounts[subtotal.totalProperty] | ulticurrency:'1.0-2':undefined:true, count: payroll.payStatusCounts[subtotal.countProperty] }">
                                  {{subtotal.labelKey}}</ukg-list-item>
                              </ukg-list>
                              <p [innerHtml]="profile.notesKey | translate"></p>
                            </div>
                          </ukg-popover>
                          <div class="flex-60 section-metadata">
                            <span class="help-cursor-hover" (click)="paygroupDetailsTooltipDisplay.present($event.target)">{{ profile.titleKey | translate }}</span>
                            <div class="flex-row flex-gap-10">
                              <ssg-currency *ngIf="profile.isInvalid"
                                [amount]="payroll.payStatusCounts[profile.totals.totalProperty]"></ssg-currency>
                              <span>{{ profile.countKey | translate:{count:
                                payroll.payStatusCounts[profile.totals.countProperty]} }}</span>
                            </div>
                          </div>
                            <ukg-popover #amountNaDetails class="at-a-glance-tooltip" type="custom">
                              <span translate>AT_A_GLANCE.PORTION_AMOUNT_NA_DETAILS</span>
                            </ukg-popover>
                          <div class="flex-40" class="section-metadata">
                            <ssg-currency *ngIf="!profile.isInvalid && payroll.payStatusCounts[profile.totals.totalProperty] > 0" [amount]="payroll.payStatusCounts[profile.totals.totalProperty]" [showFullAmount]="true" container="body" placement="right"></ssg-currency>
                            <span class="pull-right" *ngIf="profile.isInvalid" (click)="amountNaDetails.present($event.target)" mode="hover" translate>AT_A_GLANCE.PORTION_AMOUNT_NA</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ssg-expander>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ssg-expander>
  <div class="text-muted text-center text-sm text-no-data" *ngIf="!hasData" data-automation="at-a-glance-payroll-no-data-display" translate>
    AT_A_GLANCE.PAYROLLS_EMPTY
  </div>
</div>